<ng-container *ngIf="isDataSetLoaded$ | async; else loading">
  <mat-card appearance="outlined" class="mat-elevation-z0 kpi-pacing-metrics-element">
    <div class="pacing-metrics-grid">
      <section
        class="pacing-metric-tile"
        *ngFor="let item of items"
        tabindex="0"
        [class.is-active]="activeItemId === item.id"
        [ngClass]="getToneClass(item.status)"
        (mouseenter)="setActiveItem(item.id)"
        (mouseleave)="setActiveItem(null)"
        (focus)="setActiveItem(item.id)"
        (blur)="setActiveItem(null)"
      >
        <div class="tile-header">
          <div class="tile-label">{{ item.label }}</div>
          <div
            class="tile-status-pill"
            [style.color]="item.color"
            [style.background-color]="item.pillBackgroundColor"
          >
            {{ item.statusLabel }}
          </div>
        </div>

        <div class="tile-value-row">
          <span class="tile-actual">{{ item.actualDisplay }}</span>
          <span class="tile-divider">/</span>
          <span class="tile-target">{{ item.targetDisplay }}</span>
        </div>

        <div class="tile-progress" aria-hidden="true">
          <div class="tile-progress-track"></div>
          <div
            class="tile-progress-fill"
            [style.width.%]="item.progressFillPercent"
            [style.background-color]="item.color"
          ></div>
          <div
            class="tile-progress-tick"
            [style.left.%]="item.benchmarkTickPercent"
          ></div>
        </div>

        <div class="tile-footer">
          <span>{{ item.progressDisplay }}</span>
          <span>{{ item.paceDisplay }} to pace</span>
        </div>

        <div class="tile-hover-panel" *ngIf="activeItemId === item.id">
          <div class="hover-insight">
            <div class="hover-insight-label">Progress to Goal:</div>
            <div class="hover-insight-value">
              <span class="hover-insight-lead" [style.color]="item.color">{{ item.progressDisplay }}</span>
              <span>{{ item.progressText }}</span>
            </div>
          </div>
          <div class="hover-insight">
            <div class="hover-insight-label">Pace vs Benchmark:</div>
            <div class="hover-insight-value">
              <span class="hover-insight-lead" [style.color]="item.color">{{ item.paceDisplay }}</span>
              <span>{{ item.paceSupportingText }}</span>
            </div>
          </div>
          <div class="hover-insight">
            <div class="hover-insight-label">Daily Avg:</div>
            <div class="hover-insight-value">
              <span class="hover-insight-lead" [style.color]="item.color">{{ item.dailyRunRateDisplay }}</span>
              <span>{{ item.todayText }}</span>
            </div>
          </div>
        </div>
      </section>
    </div>
  </mat-card>
</ng-container>

<ng-template #loading>
  <mat-card appearance="outlined" class="mat-elevation-z0 kpi-pacing-metrics-element is-loading">
    <div class="pacing-metrics-grid">
      <div class="pacing-metric-placeholder" syncPulse></div>
      <div class="pacing-metric-placeholder" syncPulse></div>
      <div class="pacing-metric-placeholder" syncPulse></div>
      <div class="pacing-metric-placeholder" syncPulse></div>
    </div>
  </mat-card>
</ng-template>
